import { render, staticRenderFns } from "./KaarttypeBeheer.vue?vue&type=template&id=24a41981&scoped=true"
import script from "./KaarttypeBeheer.vue?vue&type=script&lang=js"
export * from "./KaarttypeBeheer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a41981",
  null
  
)

export default component.exports